import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface HomeRegimeParams extends DefaultHttpHeaders {
  /** Unique identifier of home regime */
  homeRegimeCode: string;
}

@Injectable()
export class HomeRegimeService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining home regime by code
   * Service for obtaining home regime by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundHomeRegimeById
   */
  homeRegime(params: HomeRegimeParams): Observable<ParameterResult> {
    const pathParams = {
      homeRegimeCode: params.homeRegimeCode,
    };
    return this.get<ParameterResult>({
      suffix: `/comeround/catalog/homeRegime/${pathParams.homeRegimeCode}`,
    });
  }
}
